import type { Theme } from '@mui/material/styles';

const styles = ({ spacing }: Theme) => ({
  threeDotButton: {
    marginLeft: spacing(1),
    alignSelf: 'center',
  },
  textSpacing: {
    marginTop: 24,
  },
  errorWrapper: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
  errorCodeText: {
    marginTop: 8,
  },
});

export default styles;
